import type { User } from "@bidbattles/bloks/lib/rapace";
import { cn } from "@bidbattles/bloks/lib/ui";

export function Avatar({
	className,
	user,
}: { className?: string; user: User }) {
	return (
		<span
			className={cn(
				"inline-flex items-center justify-center border rounded-full bg-accent-primary text-xs font-bold text-white border-accent-primary size-9 overflow-hidden",
				className,
			)}
		>
			{user.image_url ? (
				<img
					src={user.image_url}
					className="w-full aspect-square object-cover"
					alt={user.display_name}
					loading="lazy"
				/>
			) : user.username ? (
				user.username.at(0)
			) : (
				`${user.first_name.at(0)}.${user.last_name.at(0)}.`.toUpperCase()
			)}
		</span>
	);
}
